import { waitLocale } from '$lib/i18n';

// https://svelte.dev/docs/kit/adapter-static#Usage
export const prerender = true;
// https://svelte.dev/docs/kit/page-options#ssr
export const ssr = false;

// Wait for locale to be loaded before rendering
export const load = async () => {
  await waitLocale();
  return {};
};
